import { ComponentPropsWithoutRef, ReactElement } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ErrorBoundary from "./ErrorBoundary";
import styles from "./TabGroup.module.scss";

type ReactTabsProps = ComponentPropsWithoutRef<typeof Tabs>;

interface TabGroupProps extends Omit<ReactTabsProps, "className"> {
  hideTabIfSingle?: boolean;
  tabs: Tab[];
}
interface Tab {
  label: string;
  panel: ReactElement;
  type: string;
  enabled: boolean;
}

export default function TabGroup({
  hideTabIfSingle = true,
  tabs,
  ...rest
}: TabGroupProps) {
  return (
    <>
      {tabs.length === 1 && hideTabIfSingle ? (
        <div className={styles.lonePanel}>{tabs[0].panel}</div>
      ) : (
        <Tabs className={styles.container} {...rest}>
          <TabList className={styles.row}>
            {tabs.map(({ label }) => (
              <Tab key={label} className="vst-tab">
                {label}
              </Tab>
            ))}
          </TabList>

          {tabs.map((tab) => (
            <TabPanel key={tab.type} className={styles.panel}>
              <ErrorBoundary>{tab.panel}</ErrorBoundary>
            </TabPanel>
          ))}
        </Tabs>
      )}
    </>
  );
}
